import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import appointmentSignData from '../datas/appointment-sign'
export default {
  getSignList (ctx, data) {
    return fetch.getSignList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = appointmentSignData.getSignList(result.data)
      return result
    })
  },
  getSignNotes (ctx, data) {
    return fetch.getSignNotes(data).then(res => {
      let result = getTotalNumber(res)
      result.data = appointmentSignData.getSignNotes(result.data)
      return result
    })
  },
  signNotesDetail (ctx, id) {
    return fetch.signNotesDetail(id).then(res => {
      let result = appointmentSignData.signNotesDetail(res.data)
      return result
    })
  },
  cancelSign (ctx, id) {
    return fetch.cancelSign(id).then(res => {
      return res
    })
  },
  getSignDetail (ctx, id) {
    return fetch.getSignDetail(id).then(res => {
      return res.data
    })
  },
  exportSign (ctx, data) {
    return fetch.exportSign(data).then(res => {
      return res
    })
  },
  getHolidayOfSign (ctx, data) {
    return fetch.getHolidayOfSign(data).then(res => {
      return getTotalNumber(res)
    })
  },
  deleteHolidayOfSign (ctx, id) {
    return fetch.deleteHolidayOfSign(id).then(res => {
      return res.data
    })
  },
  deleteHolidaysOfSign (ctx, ids) {
    return fetch.deleteHolidaysOfSign(ids).then(res => {
      return res.data
    })
  },
  createHolidayOfSign (ctx, data) {
    return fetch.createHolidayOfSign(data).then(res => {
      return res.data
    })
  },
  editHolidayOfSign (ctx, data) {
    return fetch.editHolidayOfSign(data).then(res => {
      return res.data
    })
  },
  getHolidayDetail (ctx, id) {
    return fetch.getHolidayDetail(id).then(res => {
      return res.data
    })
  },
  importHolidayOfSign (ctx, data) {
    return fetch.importHolidayOfSign(data).then(res => {
      return res.data
    })
  },
  getRegisterNoteDetail (ctx, data) {
    return fetch.getRegisterNoteDetail(data).then(res => {
      return res.data
    })
  },
  editUserRegistrations (ctx, data) {
    return fetch.editUserRegistrations(data).then(res => {
      return res.data
    })
  },
  getDateIsHoliday (ctx, data) {
    return fetch.getDateIsHoliday(data).then(res => {
      return res.data
    })
  },
  confirmRegistration (ctx, id) {
    return fetch.confirmRegistration(id).then(res => {
      return res.data
    })
  },
  reportInterpreted (ctx, id) {
    return fetch.reportInterpreted(id).then(res => {
      return res.data
    })
  },
  getSignInvalid (ctx, id) {
    return fetch.getSignInvalid(id).then(res => {
      return res.data
    })
  },
  reportInterpretAllotTask (ctx, data) {
    return fetch.reportInterpretAllotTask(data).then(res => {
      return res.data
    })
  },
  addReadDetail (ctx, data) {
    return fetch.addReadDetail(data).then(res => {
      return res.data
    })
  },
  addAdditionalReadDetail (ctx, data) {
    return fetch.addAdditionalReadDetail(data).then(res => {
      return res.data
    })
  },
  repurchaseIntention (ctx, data) {
    return fetch.repurchaseIntention(data).then(res => {
      return res.data
    })
  },
  getReportAreaList (ctx, data) {
    return fetch.getReportAreaList(data).then(res => {
      return res.data
    })
  },
  setStatusPhoneNot (ctx, data) {
    return fetch.setStatusPhoneNot(data).then(res => {
      return res.data
    })
  },
  setStatusOtherReason (ctx, data) {
    return fetch.setStatusOtherReason(data).then(res => {
      return res.data
    })
  },
  getReadPersonnelList (ctx) {
    return fetch.getReadPersonnelList().then(res => {
      return res.data
    })
  },
  getAllReadPersonnelList (ctx) {
    return fetch.getAllReadPersonnelList().then(res => {
      return res.data
    })
  },
  changeAllotUser (ctx, data) {
    return fetch.changeAllotUser(data).then(res => {
      return res.data
    })
  },
  getReadPeopleDetail (ctx, data) {
    return fetch.getReadPeopleDetail(data).then(res => {
      return res.data
    })
  },
  getLifeExperienceHallsReservationAdvanced (ctx, data) {
    return fetch.getLifeExperienceHallsReservationAdvanced(data).then(res => {
      return getTotalNumber(res)
    })
  },
  getWaitAuditCount (ctx) {
    return fetch.getWaitAuditCount().then(res => {
      return res.data
    })
  },
  updateInvoiceStatus (ctx, data) {
    return fetch.updateInvoiceStatus(data).then(res => {
      return res.data
    })
  },
  financeAuditOfReservation (ctx, data) {
    return fetch.financeAuditOfReservation(data).then(res => {
      return res.data
    })
  }
}
